import Splide from '@splidejs/splide';

export const splide = {
  splideSliderMain: document.querySelector('.js-splideslider'),
  init() {
    if (this.splideSliderMain) {
      const ipadWidth = 768;
      const ipadHorizontalWidth = 1024;
      const one = 1;
      const two = 2;
      const four = 4;
      const perPageNo =
        window.innerWidth < ipadWidth
          ? one
          : window.innerWidth < ipadHorizontalWidth
          ? two
          : four;

      let slider = new Splide(this.splideSliderMain, {
        perPage: perPageNo,
        rewind: true,
        arrows: false,
        gap: 10,
      }).mount();
    }
  },
};
